<template>
    <div v-if="isVisible" class="form-item radio" :class="[item.data.htmloptions, { 'is-invalid' : isInvalid }]">

        <Label v-if="item.data.question != ''" :item="item" :is-invalid="isInvalid" />

        <div class="radio-container" :class="displayType">
            <div class="radio-item" v-for="(answer, index) in answeroptions" :key="answer.id">
                <input type="radio"
                    :id="answer.id"
                    :name="`${item.data.id}`"
                    :value="answer.value"
                    :checked="isChecked(answer)"
                    @change="updateFormValue(item.data.uniqlabel, $event.target.value)"
                >
                <label :for="answer.id"> {{ answer.label }} </label>
            </div>
        </div>

        <error-message v-if="errorMessage">{{ errorMessage }}</error-message>
    </div>
</template>

<script>
import Label from '../components/Label.vue';
import errorMixin from "../mixins/error";
import logicMixin from "../mixins/logic";
import eventBus from "../../formeditor/util/EventBus";
import ErrorMessage from "../components/ErrorMessage.vue"
import shuffle from "../util/shuffle";

export default {
    name: 'Radio',
    components: {ErrorMessage, Label },
    mixins: [errorMixin, logicMixin],
    props: {
        value: {
            type: String,
            default: ''
        },
        item: {
            type: Object
        },
        formValues: {
            type: Object
        }
    },
    data: function () {
        return {
            answeroptions: []
        };
    },
    computed: {
        displayType () {
            const display = this.item.data.display ?? 'row'

            return {
                'radio-row': display=== 'row',
                'radio-column': display === 'column'
            }
        }
    },
    mounted() {
        this.item.data.answeroptions.forEach(answer => {
            if(answer.id_default) {
                eventBus.$emit('setValue', this.item.data.id, answer.value);
            }
        });

        if(this.item.data.randomorder) {
            this.answeroptions = shuffle(answeroptions);
        }
        else {
            this.answeroptions = this.item.data.answeroptions;
        }
    },
    methods: {
        isChecked (answer) {
            if (Object.keys(this.formValues).length) {
                return answer.value == this.formValues[this.item.data.uniqlabel]
            } else {
                return answer.value == this.value
            }
        },
        updateFormValue(ident, value) {
            this.$emit('input', value)
            this.$emit('update-form-value', ident, value)
        }
    }
};
</script>